export const SELLER_USERNAME_GUIDE =
  '영문, 숫자, 밑줄(_)과 점(.)을 사용해 3~16자로 입력해주세요.';

export function isValidSellerUsername(value) {
  return /^[0-9a-zA-Z_.]{3,16}$/.test(value);
}
